import React from 'react';

const Problemssection = () => {
  return (
    <>
      <div className='relative mt-14 mb-14 lg:mb-3'>
        <div className='text-center mb-10'>
          <h4 className='font-extrabold lg:text-3xl text-xl'>Perfect Solution of Your Difficulties,</h4>
          <p className='pt-1 lg:text-4xl text-2xl lg:px-[400px]'>It is about doing the best you can with limited resources
          </p>
        </div>
        <div className='grid grid-cols-1 lg:grid-cols-2 text-[#fff]'>
          <div className='problemsolutionbg1 lg:text-right relative'>
            <h3 className='px-14 lg:text-2xl font-thin'>EASYCAMPUS,</h3>
            <h3 className='px-14 lg:text-4xl font-extrabold'>Enhancing Efficiency </h3>
            <p className='px-14 lg:pt-4 pt-2'>A comprehensive suite for managing the entire campus hiring process, EASYCAMPUS significantly boosts the efficiency of your business operations.</p>
          </div>
          <div className='problemsolutionbg2 text-left relative'>
            <h3 className='px-14 lg:text-2xl font-thin'>EASYCAMPUS,</h3>
            <h3 className='px-14 lg:text-4xl font-extrabold'>Enhancing Collaboration</h3>
            <p className='px-14 lg:pt-4 pt-2'>EASYCAMPUS is an automated and secure platform that ensures rapid response times, keeping stakeholders informed and up-to-date with various associated activities.</p>
          </div>
        </div>
      </div>
    </>

  )
}

export default Problemssection